import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/user/CreateUser.css';
import axios from 'axios';
import { getRecaptchaToken, loadRecaptcha } from '../../utils/recaptcha';

const CreateUser = () => {
  const [userData, setUserData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Pre-load reCAPTCHA script when component mounts
    if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
      loadRecaptcha().catch(err => {
        console.warn('reCAPTCHA pre-load failed:', err);
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userData.password !== userData.confirmPassword) {
      setError('Passordene stemmer ikke overens');
      return;
    }

    try {
      // Get reCAPTCHA token
      const recaptchaToken = await getRecaptchaToken('signup');
      
      if (!recaptchaToken && process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
        setError('Kunne ikke verifisere. Vennligst prøv igjen.');
        return;
      }

      // Include honeypot fields (should be empty - bots will fill these)
      const submitData = {
        ...userData,
        recaptchaToken,
        website: '', // Honeypot field
        email_confirm: '', // Honeypot field
        _submission_time: Date.now().toString()
      };

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/register`, submitData, {
        withCredentials: true
      });
      const data = response.data;
      if (data.success) {
        setSuccess(data.message);
        navigate('/login');
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Registrering feilet');
    }
  };

  return (
    <div className="create-user-container">
      <form onSubmit={handleSubmit} className="create-user-form">
        <h2>Opprett konto</h2>
        {error && <div className="error-message">{error}</div>}
        <input
          type="text"
          placeholder="Navn"
          value={userData.name}
          onChange={(e) => setUserData({...userData, name: e.target.value})}
        />
        <input
          type="email"
          placeholder="Epost"
          value={userData.email}
          onChange={(e) => setUserData({...userData, email: e.target.value})}
        />
        <input
          type="password"
          placeholder="Passord"
          value={userData.password}
          onChange={(e) => setUserData({...userData, password: e.target.value})}
        />
        <input
          type="password"
          placeholder="Bekreft passord"
          value={userData.confirmPassword}
          onChange={(e) => setUserData({...userData, confirmPassword: e.target.value})}
        />
        {/* Honeypot fields - hidden, should be empty */}
        <input
          type="text"
          name="website"
          style={{display: 'none'}}
          tabIndex="-1"
          autoComplete="off"
          value=""
          readOnly
        />
        <input
          type="text"
          name="email_confirm"
          style={{display: 'none'}}
          tabIndex="-1"
          autoComplete="off"
          value=""
          readOnly
        />
        <button type="submit">Opprett konto</button>
        {/* reCAPTCHA v3 badge - required by Google */}
        {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
          <div className="recaptcha-notice">
            <small>
              This site is protected by reCAPTCHA and the Google{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              {' '}and{' '}
              <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
              {' '}apply.
            </small>
          </div>
        )}
      </form>
    </div>
  );
};

export default CreateUser; 